import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_DOCUMENTTEMPLATE } from "../../../../utils/constants";
import { DocumentTemplateInterface } from "../../../../models/ProcurementModule/DocumentTemplate";
import documentTemplateService from "../../../../services/general/documentTemplateService";

interface AddDocumentTemplateContext {
  previousDocumentTemplates: DocumentTemplateInterface[];
}

const useAddDocumentTemplate = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    DocumentTemplateInterface,
    Error,
    DocumentTemplateInterface,
    AddDocumentTemplateContext
  >({
    mutationFn: documentTemplateService.Create,

    onMutate: () => {
      const previousDocumentTemplates =
        queryClient.getQueryData<DocumentTemplateInterface[]>([
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousDocumentTemplates: previousDocumentTemplates };
    },

    onSuccess: (savedDocumentTemplate) => {
      queryClient.setQueryData<DocumentTemplateInterface[]>(
        [
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (documentTemplates) =>
          documentTemplates
            ? [savedDocumentTemplate, ...documentTemplates]
            : [savedDocumentTemplate]
      );
    },

    onError: (error, newCompany, context) => {
      if (!context) return;

      queryClient.setQueryData<DocumentTemplateInterface[]>(
        [
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousDocumentTemplates
      );
    },
  });
};

export default useAddDocumentTemplate;
